<template>
  <div>
    Select Role
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "./../base/Base.vue";
@Options({})
export default class SelectRole extends Base {}
</script>
